import theme from '../avayaCustomized';

const primaryColor = theme.palette.nav.menuBg;

const variable = {
  primaryColor,
  primaryColorHighlight: 'rgba(87,87,89,0.4)',
  primaryColorHighlightSolid: 'rgb(187,187,188)',
  callBtnColor: '#3C9949',
  c2dArrowColor: '#ffffff',
  addMeetingBtnColor: primaryColor,
  addMeetingBtnTextColor: '#FFFFFF',
  brandFontColor: primaryColor,
  brandFontColorHighlight: 'rgba(87,87,89,0.4)',
  smsBubbleBackgroundColor: '#F3F3F3',
};

export default variable;
